import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { supplierService } from '../../services/api';
import { Supplier } from '../../types';
import { toast } from 'react-toastify';

interface SupplierFormProps {
  show: boolean;
  onHide: () => void;
  onSuccess: () => void;
  supplier?: Supplier | null;
}

const SupplierForm: React.FC<SupplierFormProps> = ({ show, onHide, onSuccess, supplier }) => {
  const [formData, setFormData] = useState({
    name: '',
    ice: '',
    if_number: '',
    rc: '',
    address: '',
    email: '',
    phone: '',
    fax: '',
    is_active: true,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (supplier) {
      setFormData({
        name: supplier.name || '',
        ice: supplier.ice || '',
        if_number: supplier.if_number || '',
        rc: supplier.rc || '',
        address: supplier.address || '',
        email: supplier.email || '',
        phone: supplier.phone || '',
        fax: supplier.fax || '',
        is_active: supplier.is_active,
      });
    } else {
      setFormData({
        name: '',
        ice: '',
        if_number: '',
        rc: '',
        address: '',
        email: '',
        phone: '',
        fax: '',
        is_active: true,
      });
    }
  }, [supplier, show]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (supplier) {
        await supplierService.update(supplier.id, formData);
        toast.success('Fournisseur modifié avec succès');
      } else {
        await supplierService.create(formData);
        toast.success('Fournisseur créé avec succès');
      }
      onSuccess();
    } catch (error) {
      console.error('Erreur lors de la sauvegarde du fournisseur', error);
      toast.error('Erreur lors de la sauvegarde');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{supplier ? 'Modifier' : 'Nouveau'} fournisseur</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nom *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>ICE</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.ice}
                  onChange={(e) => setFormData(prev => ({ ...prev, ice: e.target.value }))}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>IF</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.if_number}
                  onChange={(e) => setFormData(prev => ({ ...prev, if_number: e.target.value }))}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>RC</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.rc}
                  onChange={(e) => setFormData(prev => ({ ...prev, rc: e.target.value }))}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Adresse</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={formData.address}
              onChange={(e) => setFormData(prev => ({ ...prev, address: e.target.value }))}
            />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Téléphone</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.phone}
                  onChange={(e) => setFormData(prev => ({ ...prev, phone: e.target.value }))}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Fax</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.fax}
                  onChange={(e) => setFormData(prev => ({ ...prev, fax: e.target.value }))}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Actif"
                  checked={formData.is_active}
                  onChange={(e) => setFormData(prev => ({ ...prev, is_active: e.target.checked }))}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Annuler
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Sauvegarde...' : 'Sauvegarder'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SupplierForm;